import { render, staticRenderFns } from "./HeaderAlert.vue?vue&type=template&id=64bec773"
import script from "./HeaderAlert.vue?vue&type=script&lang=js"
export * from "./HeaderAlert.vue?vue&type=script&lang=js"
import style0 from "./HeaderAlert.vue?vue&type=style&index=0&id=64bec773&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports